<template>
  <div>
    <v-row v-if="item != undefined" justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <div class="mod-custom">
          <div class="clse">
            <v-btn icon @click.stop="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-container>
              <v-row class="custom">
                <v-col md="12">
                  <div class="md-tl">
                    <p>Invitar colaborador</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <p>
                    Se enviara una invitación a participar en
                    <b>{{ item.name }}</b>
                  </p>
                  <v-text-field
                    ref="userEmail"
                    outlined
                    v-model="userEmail"
                    :rules="emailRules"
                    label="Correo electrónico"
                    placeholder="user@email.com"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    ref="access"
                    outlined
                    v-model="access"
                    item-text="name"
                    item-value="id"
                    :items="accessItem"
                    label="Permiso"
                    :rules="fieldRules"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>

            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn
                :disabled="!valid"
                depressed
                large
                color="primary"
                @click="validate"
                >Enviar invitación</v-btn
              >
            </div>
          </v-form>
        </div>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FolderShared",
  components: {},
  props: ["visible", "item"],
  data() {
    return {
      userEmail: null,
      access: null,
      valid: true,
      emailRules: [
        (v) => !!v || "El correo electrónico es requerido.",
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "El formato no es valido"
      ],
      accessItem: [
        {
          id: "edit",
          name: "Editar"
        },
        {
          id: "read",
          name: "Leer"
        }
      ],
      fieldRules: [(v) => !!v || "El campo es requerido"]
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
      }
    });
  },
  updated() {},
  watch: {},
  methods: {
    ...mapActions(["sharedFolder"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerInvite();
        //console.log("shared Folder");
      }
    },
    // async registerInvite() {
    //   console.log('enviando invitacion')
    // },
    async registerInvite() {
      try {
        let formSend = {
          email: this.userEmail,
          space: this.item.space,
          file: this.item._id,
          access: this.access
        };
        //console.log(formSend);
        let responsed = await this.sharedFolder(formSend);
        if (responsed == 200) {
          //console.log("creado", responsed);
          this.$root.$emit("reload");
          this.$root.$emit("snackbar", {
            status: 200,
            visible: true,
            text: `Se envio la invitación ${this.userEmail}.`
          });
          this.$refs.form.reset();
          this.show = false; // parametro update tabla
        }
      } catch (error) {
        this.$refs.form.reset();
        //console.log("error catch", error);
        this.$root.$emit("snackbar", {
          status: 404,
          visible: true,
          text: `Ocurrió un error inesperado - ${error}`
        });
        this.show = false;
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      }
    }
  }
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
